/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const VolunteerReport = {

	getConfiguration (context, volunteerReportId, onSuccess, onError, options) {
		Api.get(context,
			"/volunteer-report/configuration"
			+ "?volunteerReportId=" + volunteerReportId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getFilledReport (context, volunteerReportId, onSuccess, onError, options) {
		Api.get(context,
			"/volunteer-report/filled-report"
			+ "?volunteerReportId=" + volunteerReportId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getProjectReports (context, projectId, onSuccess, onError, options) {
		Api.get(context,
			"/volunteer-report/project-reports"
			+ "?projectId=" + projectId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	postExportBySearchCriteria (context, contestId, projectReportExportDTO, onSuccess, onError, options) {
		Api.post(context,
			"/volunteer-report/export-by-search-criteria"
			+ "?contestId=" + contestId
			, projectReportExportDTO
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putCorrection (context, dto, onSuccess, onError, options) {
		Api.put(context,
			"/volunteer-report/correction"
			, dto
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putData (context, volunteerReportId, dto, onSuccess, onError, options) {
		Api.put(context,
			"/volunteer-report/data"
			+ "?volunteerReportId=" + volunteerReportId
			, dto
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putFinish (context, volunteerReportId, dto, onSuccess, onError, options) {
		Api.put(context,
			"/volunteer-report/finish"
			+ "?volunteerReportId=" + volunteerReportId
			, dto
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	putStart (context, volunteerReportId, onSuccess, onError, options) {
		Api.put(context,
			"/volunteer-report/start"
			+ "?volunteerReportId=" + volunteerReportId
			, null
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
